import React from 'react';
import { Theme, makeStyles } from '@material-ui/core/styles';
import BreadcrumbBar from '../../@common/Breadcrumb/BreadcrumbBar';
import useBreadcrumbs from 'hooks/use-breadcrumbs';
import { RouteConfig } from 'types';

interface NavBarProps {
  breadcrumbs?: { name: string; path: string }[];
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      alignItems: 'center',
      justifyContent: 'space-between',
      minHeight: 46,
      background: 'white',
      width: '100%',
      borderBottom: `1px solid ${theme.palette.divider}`,
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'flex'
      }
    },
    breadcrumbContainer: {
      flexGrow: 1,
      paddingLeft: theme.spacing(5)
    },
    sortContainer: {
      paddingRight: theme.spacing(4),
      display: 'flex',
      alignItems: 'flex-end',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'flex-end'
      }
    },
    button: {
      borderRadius: 4,
      padding: `${theme.spacing(1) / 2}px ${theme.spacing(1)}px`
    },
    sortIcon: {
      fontSize: '24px'
    }
  };
});

const Navbar: React.FC<RouteConfig> = ({ children, ...props }) => {
  const classes = useStyles();
  const breadcrumbs = useBreadcrumbs(props);

  return (
    <div className={classes.container}>
      <BreadcrumbBar breadcrumbs={breadcrumbs} />
      <div className={classes.sortContainer}>{children}</div>
    </div>
  );
};

export default Navbar;
